import { useRef, useState } from 'react'
import { FieldError, getFieldErrorMessage, PasswordIcon, scrollFocus } from '../../base'
import { useDispatch } from 'react-redux'
import { resetPassword } from '../../redux/UserSlice'

function ResetPassword() {
    const [error, setError] = useState(null)
    const [oldPassword, setOldPassword] = useState('')
    const [newPassword, setNewPassword] = useState('')
    const [showNewPassword, setShowNewPassword] = useState(false)
    const [showOldPassword, setShowOldPassword] = useState(false)
    const dispatch = useDispatch()

    const refrence = {
        oldRef: useRef(null),
        newRef: useRef(null)
    }

    function reset() {
        const trimmed_new_password = newPassword.trim().replace(/\s+/g, '')
        if (oldPassword === '') {
            setError(getFieldErrorMessage('Enter your old password !', 'old_password'))
            scrollFocus(refrence.oldRef)
        }
        else if (trimmed_new_password === '' || trimmed_new_password.length < 6) {
            setError(getFieldErrorMessage('Minimum 6 characters requried !', 'new_password'))
            scrollFocus(refrence.newRef)
        }
        else {
            dispatch(resetPassword({ 'old_password': oldPassword, 'new_password': newPassword }))
        }
    }


    return (
        <div className='row mt-4'>
            <div className='col-12 col-md-6'>
                <label>Old Password</label>
                <div className='position-relative'>
                    <input ref={refrence.oldRef} type={showOldPassword ? 'text' : 'password'} value={oldPassword} onChange={(e) => setOldPassword(e.target.value)} placeholder='Your Old password' />
                    <span className='passwordIconSpan' onClick={() => setShowOldPassword(!showOldPassword)}><PasswordIcon show={showOldPassword} /></span>
                </div>
                <FieldError error={error} field='old_password' setError={setError} />
            </div>
            <div className='col-12 col-md-6'>
                <label>New Password</label>
                <div className='position-relative'>
                    <input ref={refrence.newRef} type={showNewPassword ? 'text' : 'password'} value={newPassword} onChange={(e) => setNewPassword(e.target.value)} placeholder='Minimum 6 characters !' />
                    <span className='passwordIconSpan' onClick={() => setShowNewPassword(!showNewPassword)}><PasswordIcon show={showNewPassword} /></span>
                </div>
                <FieldError error={error} field='new_password' setError={setError} />
            </div>
            <div className='col-12 col-md-12 mt-4'>
                <button className='secondryButton h5' onClick={() => reset()}>Reset </button>
            </div>
        </div>
    )
}

export default ResetPassword